import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useLanguage } from '../App';
import { t } from '../i18n';
import { motion } from 'framer-motion';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { token, fetchUser } = useAuth();
  const { language } = useLanguage();
  const [status, setStatus] = useState('verifying');
  const [plan, setPlan] = useState('');

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId || !token) {
      navigate('/pricing');
      return;
    }
    const verify = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/stripe/verify/${sessionId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.status === 'success') {
          setPlan(data.plan);
          setStatus('success');
          fetchUser();
        } else {
          setStatus('pending');
        }
      } catch (e) {
        setStatus('error');
      }
    };
    verify();
  }, []);

  return (
    <div className="auth-page">
      <motion.div className="auth-card" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}>
        {status === 'verifying' && (
          <>
            <div className="lb-spinner" style={{ margin: '0 auto 16px' }} />
            <h2 style={{ fontFamily: 'Nunito', fontSize: '22px', fontWeight: 900 }}>{t('verifyingPayment', language)}</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={{ fontSize: '56px', marginBottom: '12px' }}>&#127881;</div>
            <h2 style={{ fontFamily: 'Nunito', fontSize: '26px', fontWeight: 900, color: '#22c55e' }}>{t('paymentSuccess', language)}</h2>
            <p style={{ color: '#666', marginTop: '8px', marginBottom: '20px' }}>
              {t('upgradedTo', language)} <strong>{plan.toUpperCase()}</strong>
            </p>
            <button className="auth-submit" onClick={() => navigate('/')}>{t('backToHome', language)}</button>
          </>
        )}
        {status === 'pending' && (
          <>
            <div style={{ fontSize: '56px', marginBottom: '12px' }}>&#9203;</div>
            <h2 style={{ fontFamily: 'Nunito', fontSize: '22px', fontWeight: 900 }}>{t('paymentPending', language)}</h2>
            <button className="auth-submit" style={{ marginTop: '16px' }} onClick={() => navigate('/')}>{t('backToHome', language)}</button>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ fontSize: '56px', marginBottom: '12px' }}>&#10060;</div>
            <h2 style={{ fontFamily: 'Nunito', fontSize: '22px', fontWeight: 900, color: '#ef4444' }}>{t('paymentError', language)}</h2>
            <button className="auth-submit" style={{ marginTop: '16px' }} onClick={() => navigate('/pricing')}>{t('tryAgain', language)}</button>
          </>
        )}
      </motion.div>
    </div>
  );
}
